import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Forbidden, PageSpinner } from '@ohpen/enso-ui';
import { useAuthz } from '@ohpen/react-authz';

import { getSideBarItems } from '../components/AppLayout/sideBarItems';
import { useHostChrome } from '@pmp/contexts';

const PREFERRED_LANDING_KEY = 'products';

export const DefaultRedirect = () => {
  const { userPermissions, envFeatureFlags, isLoading } = useAuthz();
  const { portalName } = useHostChrome();

  // Landing page is derived from the guarded side bar so it can never point at a
  // surface the route guard denies.
  const landingKey = useMemo(() => {
    const keys = getSideBarItems(userPermissions, envFeatureFlags).flatMap(item =>
      item && item.type !== 'divider' && item.key ? [String(item.key)] : [],
    );
    return keys.includes(PREFERRED_LANDING_KEY) ? PREFERRED_LANDING_KEY : keys[0];
  }, [userPermissions, envFeatureFlags]);

  if (isLoading) return <PageSpinner />;
  if (!landingKey) return <Forbidden showBackButton={false} appName={portalName} />;

  return <Navigate to={landingKey} replace />;
};
